export const JWT_ACCESS_TOKEN = 'dk_access_token';
